interface EventProperties {
  '[Community] Page Type'?: string,
  '[Community] Topic Type'?: string,
  '[Community] Topic Title'?: string,
  '[Community] Category Title'?: string,
  '[Community] Public Tags'?: string[]
}

export default (): void => {
  const { inSidedData, mixpanel } = window
  const eventProperties: EventProperties = getEventProperties(inSidedData)
  if (eventProperties) {
    mixpanel.track('[Community] Page Viewed', eventProperties)
  }
}

const getEventProperties = (data: any): EventProperties => {
  switch (data.page.name) {
    case 'Home':
      return {
        '[Community] Page Type': 'Homepage'
      }
    case 'Category':
      return {
        '[Community] Page Type': 'Category',
        '[Community] Category Title': data.content.category.title
      }
    case 'Topic':
      const tags = data.content.topic.tags
      return {
        '[Community] Page Type': 'Topic',
        '[Community] Topic Type': data.content.topic.type === 'discussion' ? 'conversation' : data.content.topic.type,
        '[Community] Topic Title': data.content.topic.title,
        '[Community] Category Title': data.content.category.title,
        '[Community] Public Tags': tags ? tags.split(',') : []
      }
    case 'Event':
      return {
        '[Community] Page Type': 'Topic',
        '[Community] Topic Type': 'Event',
        '[Community] Topic Title': document.querySelector('.twig_page-event .event__title')?.textContent || ''
      }
    default:
      return {}
  }
}
